import React from 'react';
import EditorDelete from '@wix/da-ds/pkg/Icons/24x24/EditorDelete';
import { useTranslation } from 'react-i18next';
import EditorIconButton from '../../../../components/menus/_partials/EditorIconButton';
const Delete = ({ editor })=>{
    const { t } = useTranslation('editor');
    return /*#__PURE__*/ React.createElement(EditorIconButton, {
        featureId: "node:gallery:delete",
        icon: EditorDelete,
        onClick: ()=>editor.chain().focus().daGalleryDelete().run(),
        tooltipText: t('ext.gallery.button.delete'),
        "aria-label": t('ext.gallery.button.delete')
    });
};
Delete.displayName = 'Delete';
export default Delete;

//# sourceMappingURL=Delete.js.map